import { render } from "./ContentblockText.vue?vue&type=template&id=31cc66d9&scoped=true&ts=true"
import script from "./ContentblockText.ts?vue&type=script&lang=ts"
export * from "./ContentblockText.ts?vue&type=script&lang=ts"

import "./ContentblockText.scss?vue&type=style&index=0&id=31cc66d9&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cc66d9"]])

export default __exports__